<template>
  <div class="yh-page">
    <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
      <el-row>
        <el-col :span="24" class="border-top mt-2 pt-3">
          <policy-table-info :policy_table_info="new_policy_table"></policy-table-info>
        </el-col>
      </el-row>

      <el-form v-if="notRestricted" :rules="rules" ref="dataForm" :model="new_policy_table" label-position="right"
        label-width="150px">
        <!--          <el-col :span="12">-->
        <!--            <el-form-item label="编辑开关">-->
        <!--              <el-switch v-model="is_disable" active-color="#ff4949" inactive-color="#13ce66"> </el-switch>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--          <el-col :span="6">-->
        <!--            <el-form-item label="保费"><el-input v-model="new_policy_table.premium"></el-input></el-form-item></el-col>-->
        <el-row>
          <el-col :span="6">业务属性</el-col>
          <el-col :span="18">
            是否共保
            <el-radio-group v-model="isCoInsurance" @change="setIsCoInsuranceValue">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            &nbsp;&nbsp;是否团体险
            <el-radio-group v-model="isGroupInsurance" @change="setIsGroupInsuranceValue">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            &nbsp;&nbsp;是否竞价业务
            <el-radio-group v-model="isBid" @change="setIsBidValue">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18" :offset="6">
            <el-button type="primary" size="mini" @click="showBizInfoInput">
              业务信息</el-button>
            <el-button type="primary" size="mini" @click="showBizRelInfoInput">
              业务关系</el-button>
            <el-button type="primary" size="mini" @click="showServiceInfoInput" v-show="showFinanceInfo">
              财务信息</el-button>
            <el-button type="primary" size="mini" @click="showServiceInfoInputSimple" v-show="showFinanceInfoSimple">
              财务信息(简)</el-button>
            <el-button type="primary" size="mini" @click="showShipInfoInput">
              船舶信息</el-button>
            <el-button type="primary" size="mini" @click="showInsuredTable">
              团体险信息</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-form :rules="rules" ref="dataForm" :model="new_policy_table" label-position="right" label-width="160px">
        <el-row v-if="showFinanceInfo">
          <el-col>
            <el-form-item>
              <div class="formula_form_head">直接调整金额部分会造成得出不正确的计算结果，请通过调整比例来进行金额修改</div>
              <div class="formula_form">手续费收入&nbsp;=&nbsp;保费&nbsp;*&nbsp;手续费比例&nbsp;/&nbsp;手续费税率调整
                &nbsp;&nbsp; &nbsp;&nbsp;{{ new_policy_table.commission }}&nbsp;=&nbsp;
                {{ new_policy_table.premium }}&nbsp;*&nbsp;{{ new_policy_table.commission_rate }}&nbsp;/&nbsp;{{
                    new_policy_table.vat_rate
                }}
              </div>
              <div class="formula_form">扣减税金&nbsp;=&nbsp;手续费收入 / 1.06 * 0.0672
                &nbsp;&nbsp; &nbsp;&nbsp;{{ new_policy_table.vat }}&nbsp;=&nbsp;
                {{ new_policy_table.commission }}&nbsp;/&nbsp;1.06&nbsp;*&nbsp;0.0672</div>
              <div class="formula_form">乙禾手续费&nbsp;=&nbsp;手续费收入&nbsp;-&nbsp;佣金支出&nbsp;-&nbsp;扣减税金
                &nbsp;&nbsp; &nbsp;&nbsp;{{ new_policy_table.commission_2yihe }}&nbsp;=&nbsp;
                {{
                    new_policy_table.commission
                }}&nbsp;-&nbsp;{{ new_policy_table.commission_2agent }}&nbsp;-&nbsp;{{ new_policy_table.vat }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="correct_list.length > 0">
          <el-col :span="24">
            <el-table :key="0" :data="correct_list" stripe border
                fit highlight-current-row class="w-100">
              <!-- 批单号 -->
              <el-table-column align="left" label="批单号"  width="200px">
                <template slot-scope="scope">
                  <span>{{scope.row.policy_number}}</span>
                </template>
              </el-table-column>

              <!-- 批改类型 -->
              <el-table-column align="left" label="批改类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.correct.type_name }}</span>
                </template>
              </el-table-column>

              <!-- 批改项目 -->
              <el-table-column align="left" label="批改项目">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.correct.change_list" :key="item">
                    <span class="badge badge-info">{{ item }}</span>
                  </div>
                  <!--<span>{{ scope.row.correct_item }}</span>-->
                </template>
              </el-table-column>

              <!-- 批改日期 -->
              <el-table-column align="left" label="批改日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.correct.update_time | parseTime('{y}-{m}-{d}') }}</span>
                </template>
              </el-table-column>

              <!-- 操作 -->
              <el-table-column align="left" label="操作" >
                <template slot-scope="scope">
                  <el-tooltip effect="light" content="查看" placement="top-start">
                    <el-button type="text" class="pr-1" @click="toView(scope.row.id)">
                      <i class="el-icon-view"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip effect="light" content="编辑" placement="top-start">
                    <el-button type="text" class="pr-1" @click="toEdit(scope.row.id)">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
     

        <el-row>
          <el-col :span="24">
            <!-- 保单文件 -->
            <el-form-item label="保单文件" prop="attachments">
              <el-upload :data="new_policy_table" ref="upload" :headers="headers" action="" :file-list="attachment_list"
                :on-remove="handleRemoveAttachmentFile" :on-preview="handlePreviewAttachmentFile"
                :before-remove="beforeRemoveAttachmentFile"
                :http-request="addAttachment" :auto-upload="false" :multiple="true">
                <!-- <el-button v-if="pageStatus === 'action.add' || pageStatus === 'action.edit'" slot="trigger"
                  size="small" type="success">选择附件</el-button> -->
              </el-upload>
              <div>
                <el-button @click="openDialog">发送附件</el-button>
              </div>
            </el-form-item>

            <!-- 条款信息 -->
            <el-form-item v-if="new_policy_table.clause" label="条款信息" prop="clause" style="width: 45.8%">
              <el-input v-model="new_policy_table.clause" disabled>
                <el-button slot="append" @click="handleClause">已补充条款</el-button>
              </el-input>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" prop="remark" style="width: 45.8%">
              <el-input type="textarea" :rows="4" placeholder="请输入备注信息" v-model="new_policy_table.remark">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="border-top mt-2 pt-3">
            <el-form-item>
              <el-button size="small" @click="cancelData">返回</el-button>
              <el-button v-if="pageStatus == 'action.edit' && showEdit" size="small" type="primary"
                @click="saveData(3)">保存
              </el-button>
              <template v-if="pageStatus == 'action.add' && showAdd">
                <el-button size="small" type="primary" @click="saveData(1)">保存</el-button>
                <el-button size="small" type="primary" @click="saveData(2)">保存并新增</el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <biz-info-input :policy_number="new_policy_table.policy_number" :ship_name="new_policy_table.ship_name"
      :applicant="new_policy_table.applicant"
      :insured="new_policy_table.insured" :effective_date="new_policy_table.effective_date"
      :expiration_date="new_policy_table.expiration_date" :issue_month="new_policy_table.issue_month"
      :business_type="new_policy_table.business_type" :is_disabled="is_disable" :premium="new_policy_table.premium"
      ref="biz_info_input" @change="handleBizInfoChange"></biz-info-input>

    <biz-relation-info-input :business_area="new_policy_table.business_area"
      :business_source="new_policy_table.business_source" :referrer="new_policy_table.referrer"
      :escrow_agent="new_policy_table.escrow_agent" :group_names="new_policy_table.group_names"
      :group_ids="new_policy_table.group_ids" :is_disabled="is_disable" ref="biz_relation_info_input"
      @change="handleBizRelationInfoChange"></biz-relation-info-input>

    <serv-info-input ref="serv_info_input" :policy_number="new_policy_table.policy_number"
      :insurance_company="new_policy_table.insurance_company"
      :insurance_company_branch_office="new_policy_table.insurance_company_branch_office"
      :insurance_type="new_policy_table.insurance_type" :commission_rate="new_policy_table.commission_rate"
      :commission_2agent_rate="new_policy_table.commission_2agent_rate" :vat_rate="new_policy_table.vat_rate"
      :premium="new_policy_table.premium" :commission="new_policy_table.commission"
      :commission_2agent="new_policy_table.commission_2agent" :vat="new_policy_table.vat"
      :commission_2yihe="new_policy_table.commission_2yihe" :invoice_rate="new_policy_table.invoice_rate"
      :un_invoice_rate="new_policy_table.un_invoice_rate" :invoice="new_policy_table.invoice"
      :un_invoice="new_policy_table.un_invoice" :services="new_policy_table.service_contents"
      @change="handleFinInfoChange"></serv-info-input>

    <serv-info-input-simple ref="serv_info_input_simple"
      :insurance_company="new_policy_table.insurance_company"
      :insurance_company_branch_office="new_policy_table.insurance_company_branch_office"
      :insurance_type="new_policy_table.insurance_type"
      :commission_2agent_rate="new_policy_table.commission_2agent_rate"
      :premium="new_policy_table.premium"
      :commission_2agent="new_policy_table.commission_2agent"
      @change="handleSimpleFinInfoChange"></serv-info-input-simple>

    <ship-info-input :ship_age="new_policy_table.ship_age" :ship_type="new_policy_table.ship_type"
      :port_of_registry="new_policy_table.port_of_registry" :sailing_area="new_policy_table.sailing_area"
      :total_tons="new_policy_table.total_tons" :dwt="new_policy_table.dwt" :is_disabled="is_disable"
      :ship_name="new_policy_table.ship_name"
      ref="ship_info_input" @change="handleShipInfoChange"></ship-info-input>

    <insured-info-table ref="insured_info_table" :insureds="new_policy_table.insureds"
      @change="handleInsuredInfoChange"></insured-info-table>
    <el-dialog title="发送附件" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <!-- <span>这是一段信息</span> -->
      <el-form ref="form" :model="form" label-width="250px">、

        <!-- <el-form-item label="接收人">
          <el-input v-model="form.recipient_list"></el-input>
        </el-form-item> -->
        <el-form-item label="接收人">
          <el-select v-model="form.recipient_list"  multiple placeholder="请选择" style="width:418px">
            <el-option v-for="item in recipient_list" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自定义收件邮箱">
          <email-address v-if="! loading" :address-list.sync="form.custom_recipient_list" button-text="+添加收件人"></email-address>
        </el-form-item>

        <el-form-item label="请输入邮件内容">
          <el-input v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item label="请选择要发送的附件">
          <el-select v-model="form.fileId" multiple placeholder="请选择">
            <el-option v-for="item in attachment_list" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="请输入您的邮箱密码">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  createPolicyTable,
  fetchPolicyTable,
  updatePolicyTable,
  fetchPolicyTableAttachmentList,
  deletePolicyTableAttachment,
  fetchEmailformList,
  PolicCustomerList,
  fetchPolicyTableCorrectList,
} from '@/api/policy'
import { getToken } from '@/utils/auth'
import { formatDate2 } from "@/utils/misc"
import PolicyTableInfo from './components/policy-info-table'
import ShipInfoInput from './components/ship-info-input'
import BizRelationInfoInput from './components/biz-relation-info-input'
import BizInfoInput from './components/biz-info-input'
import ServInfoInput from './components/service-info-input'
import ServInfoInputSimple from './components/service-info-input-simple'
import InsuredInfoTable from "@/views/ib/policy/components/insured-info-table";
import { fetchDefaultScheme } from '../../../api/insurance_type'
import EmailAddress from '@/components/EmailAddress'

export default {
  name: "policy-table-detail",
  components: {
    PolicyTableInfo,
    BizInfoInput,
    ServInfoInput,
    ServInfoInputSimple,
    BizRelationInfoInput,
    ShipInfoInput,
    InsuredInfoTable,
    EmailAddress,
  },
  computed: {
    headers() {
      return { 'Authorization': 'Token ' + getToken() }
    }
  },
  data() {
    return {
      /* 页面状态变量开始 */
      customer_list: [],
      showAdd: false,
      showEdit: false,
      pageStatus: '',
      recipient_list: [],
      notRestricted: false,
      showFinanceInfo: false,
      showFinanceInfoSimple: false,
      save_type: null,
      loading: false,
      loadingText: '正在加载数据，请销等...',
      is_disable: true,
      id: null,
      /* 页面状态变量结束 */
      //保单弹框显影
      dialogVisible: false,
      form: {
        recipient_list:'',
        password: '',
        content: '',
        fileId: '',
        file_list: [],
        custom_recipient_list: [],
      },
      /* 业务属性部分 */
      // 是否共保
      isCoInsurance: 0,
      // 是否团体险
      isGroupInsurance: 0,
      // 是否竞价业务
      isBid: 0,

      // 必填项
      rules: {
      },

      new_policy_table: {
        id: 0,
        policy_number: "",
        ship_name: "",
        insured: "",
        applicant: "",
        effective_date: "",
        expiration_date: "",
        issue_month: "",
        business_type: "",

        insurance_company: "",
        insurance_company_branch_office: "",
        insurance_type: "",
        commission_rate: 0,
        commission_2agent_rate: 0,

        premium: 0,
        vat_rate: 1,
        commission: 0,
        commission_2agent: 0,
        vat: 0,
        commission_2yihe: 0,
        invoice_rate: 0,
        un_invoice_rate: 0,
        invoice: 0,
        un_invoice: 0,

        no: 0,
        has_receipt: "",
        insurance_type_code: '',
        // commission_2agent_paid_date: "",
        // commission_collection_date: "",

        ship_age: 0,
        ship_type: "",
        port_of_registry: "",
        sailing_area: "",
        dwt: 0,
        total_tons: 0,

        is_reconciled: null,
        is_coinsurance: 0,
        is_group_insurance: 0,
        is_bid: 0,
        group: [],
        group_ids: [],
        group_names: [],
        remark: '',
        clause: '',
        insureds: [],
        service_contents: [],
      },
      // 用于临时计算的字段开始
      c2_commission: 0,
      c2_commission_2agent: 0,
      c2_vat: 0,
      c2_commission_2yihe: 0,
      c2_invoice_rate: 0,
      c2_invoice: 0,
      c2_un_invoice_rate: 0,
      c2_un_invoice: 0,
      // 用于临时计算的字段结束

      submitForm: new FormData(),

      // 附件列表
      attachment_list: [],
      insureds: [],
      correct_list: [],
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    submitBtn() {

      let file_list = []
      this.attachment_list.forEach((i) => {
        if (this.form.fileId.includes(i.id)) {
          file_list.push(i)
        }
      })
      this.form.file_list = file_list
      delete this.form.fileId
      this.submitFile()
    },
    submitFile() {
      fetchEmailformList(this.form)
        .then(res => {
          this.list = res.results
          this.total = res.count
          this.loading = false
          this.dialogVisible = false
          this.$message.success('发送邮件成功!')
        })
        .catch(error => {
          this.loading = false
          this.$error_message(error)
        })
    },
    getCustomerList() {
          PolicCustomerList({ insured: this.new_policy_table.applicant }).then(res => {
        this.recipient_list = res.result
        console.log(this.recipient_list)
      })
     },
    openDialog() {
      this.getCustomerList()

      this.dialogVisible = true


    },
    handleSelectionChange(arr) {
      console.log(arr)
    },
    getDateTime(value) {
      let oldDate = new Date(value).getTime()
      let newDate = new Date(oldDate)
      return formatDate2(newDate)
    },

    /* 数据加载与重置开始 */
    loadData() {
    },
    reset_options() {
      // this.settingValue = []
      // this.c2_commission = 0
      // this.c2_commission_2agent = 0
      // this.c2_vat = 0
      // this.c2_commission_2yihe = 0
      // this.c2_invoice_rate = 0
      // this.c2_invoice = 0
      // this.c2_un_invoice_rate = 0
      // this.c2_un_invoice = 0
      this.attachment_list = []
    },

    reset_new_policy_table() {
      this.new_policy_table.id = 0
      this.new_policy_table.policy_number = ""
      this.new_policy_table.ship_name = ""
      this.new_policy_table.insured = ""
      this.new_policy_table.applicant = ""

      this.new_policy_table.effective_date = ""
      this.new_policy_table.expiration_date = ""
      this.new_policy_table.issue_month = ""

      this.new_policy_table.business_type = ""
      this.new_policy_table.business_area = ""
      this.new_policy_table.business_source = ""
      this.new_policy_table.referrer = ""
      this.new_policy_table.escrow_agent = ""

      this.new_policy_table.insurance_company = ""
      this.new_policy_table.insurance_company_branch_office = ""
      this.new_policy_table.insurance_type = ""
      this.new_policy_table.commission_rate = 0
      this.new_policy_table.commission_2agent_rate = 0
      this.new_policy_table.vat_rate = 1

      this.new_policy_table.premium = 0
      this.new_policy_table.commission = 0
      this.new_policy_table.commission_2agent = 0
      this.new_policy_table.vat = 0
      this.new_policy_table.commission_2yihe = 0
      this.new_policy_table.invoice_rate = 0
      this.new_policy_table.un_invoice_rate = 0
      this.new_policy_table.invoice = 0
      this.new_policy_table.un_invoice = 0

      this.new_policy_table.no = 0
      this.new_policy_table.has_receipt = ""
      this.new_policy_table.insurance_type_code = ''
      // this.new_policy_table.commission_collection_date = null
      // this.new_policy_table.commission_2agent_paid_date = null

      this.new_policy_table.ship_age = 0
      this.new_policy_table.ship_type = ""
      this.new_policy_table.port_of_registry = ""
      this.new_policy_table.sailing_area = ""
      this.new_policy_table.dwt = 0
      this.new_policy_table.total_tons = 0

      this.new_policy_table.is_reconciled = null
      this.new_policy_table.is_group_insruance = 0
      this.new_policy_table.is_bid = 0
      this.new_policy_table.is_coinsurance = 0
      this.new_policy_table.group = []
      this.new_policy_table.group_ids = []
      this.new_policy_table.group_names = []
      this.new_policy_table.remark = ''
      this.new_policy_table.clause = ''
    },
    /* 数据加载与重置结束 */



    /* 选择项处理开始 */
    getIsBidValue() {
      this.isBid = this.new_policy_table.is_bid
    },
    setIsBidValue() {
      this.new_policy_table.is_bid = this.isBid
    },
    getIsCoInsuranceValue() {
      this.isCoInsurance = this.new_policy_table.is_coinsurance
    },
    setIsCoInsuranceValue() {
      this.new_policy_table.is_coinsurance = this.isCoInsurance
    },
    getIsGroupInsuranceValue() {
      this.isGroupInsurance = this.new_policy_table.is_group_insurance
    },
    setIsGroupInsuranceValue() {
      this.new_policy_table.is_group_insurance = this.isGroupInsurance
    },


    // changeIsGroupInsurance(selectedValue){
    //   for (let company of this.settingOptions){
    //     if (company.value === selectedValue[0]){
    //       for (let branch_office of company.children){
    //         if (branch_office.value === selectedValue[1]){
    //           for (let insurance_type of branch_office.children){
    //             if (insurance_type.value === selectedValue[2]){
    //               this.isGroupInsurance = insurance_type.is_group_insurance
    //               this.setIsGroupInsuranceValue()
    //             }
    //           }
    //         }
    //         break
    //       }
    //       break
    //     }
    //   }
    // },
    // 处理设置变更
    // handleSettingChange(value) {
    //   this.changeIsGroupInsurance(value)
    //   if(value[0] !== null && value[0] !== undefined){
    //     this.new_policy_table.insurance_company = value[0]
    //   }
    //   if(value[1] !== null && value[1] !== undefined){
    //     this.new_policy_table.insurance_company_branch_office = value[1]
    //   }
    //   if(value[2] !== null && value[2] !== undefined){
    //     this.new_policy_table.insurance_type = value[2]
    //   }
    //   if(value[3] !== null && value[3] !== undefined){
    //     this.new_policy_table.commission_rate = value[3]
    //   }
    //   if(value[4] !== null && value[4] !== undefined){
    //     this.new_policy_table.commission_2agent_rate = value[4]
    //   }
    //   this.calcCommission()
    // },
    // 处理业务区域变更
    initBusinessArea() {
      let areas = this.new_policy_table.group
      if (areas instanceof Array) {
        this.new_policy_table.group_ids = []
        this.new_policy_table.group_names = []
        for (let i = 0; i < areas.length; i++) {
          this.new_policy_table.group_ids.push(areas[i].id)
          this.new_policy_table.group_names.push(areas[i].name)
        }
        this.new_policy_table.business_area = this.new_policy_table.group_names.join(',')
      }
    },
    // handleSelectedBusinessArea(areas){
    //   if (areas instanceof Array){
    //     this.new_policy_table.group_ids = []
    //     this.new_policy_table.group_names = []
    //     for (let i=0; i<areas.length; i++){
    //       for (let businessArea of this.businessAreaOptions){
    //         if(businessArea.value === areas[i]){
    //           this.new_policy_table.group_ids.push(businessArea.value)
    //           this.new_policy_table.group_names.push(businessArea.label)
    //         }
    //       }
    //     }
    //     this.new_policy_table.business_area = this.new_policy_table.group_names.join(',')
    //   }
    // },
    /* 选择项处理结束 */
    showBizInfoInput() {
      this.$refs.biz_info_input.showDialog()
    },
    showInsuredTable() {
      this.$refs.insured_info_table.showDialog()
    },
    showServiceInfoInput() {
      this.$refs.serv_info_input.showDialog()
    },
    showServiceInfoInputSimple() {
      if (this.new_policy_table.services_num > 0) {
        this.$error_message("对账数据已录入，非对账人员不可操作！")
        return
      }

      this.$refs.serv_info_input_simple.showDialog()
    },
    showShipInfoInput() {
      this.$refs.ship_info_input.showDialog()
    },
    showBizRelInfoInput() {
      this.$refs.biz_relation_info_input.showDialog()
    },

    /* 费用计算及检查开始 */
    // 计算手续费变更
    calcCommission(isFlush = true) {
      if (isFlush) {
        this.$message.info('重新计算手续费')
      }
      let c_premium = parseFloat(this.new_policy_table.premium)
      let c_commission_rate = parseFloat(this.new_policy_table.commission_rate)
      let c_commission_2agent_rate = parseFloat(this.new_policy_table.commission_2agent_rate)
      let c_commission = 0
      let c_vat = 0
      let c_commission_2agent = 0
      let c_commission_2yihe = 0

      // 手续费、税金扣减、佣金、乙禾手续费计算
      // c_commission = ((c_premium * c_commission_rate) / this.new_policy_table.vat_rate).toFixed(4)
      // c_vat = (c_commission / 1.06 * 0.0672).toFixed(4)
      // c_commission_2agent = (c_premium * c_commission_2agent_rate).toFixed(4)
      // c_commission_2yihe = (c_commission - c_vat - c_commission_2agent).toFixed(4)

      if (this.new_policy_table.services === undefined) {
        if (Array.isArray(this.new_policy_table.service_contents)) {
          this.new_policy_table.service_contents.forEach((item, i) => {
            c_commission += parseFloat(item.commission)
            c_vat += parseFloat(item.vat)
            c_commission_2agent += parseFloat(item.commission_2agent)
            c_commission_2yihe += parseFloat(item.commission_2yihe)
          })
        }
      } else {
        if (Array.isArray(this.new_policy_table.services)) {
          this.new_policy_table.services.forEach((item, i) => {
            c_commission += parseFloat(item.commission)
            c_vat += parseFloat(item.vat)
            c_commission_2agent += parseFloat(item.commission_2agent)
            c_commission_2yihe += parseFloat(item.commission_2yihe)
          })
        }
      }

      // 缓存计算结果
      this.c2_commission = c_commission.toFixed(4)
      this.c2_vat = c_vat.toFixed(4)
      this.c2_commission_2agent = c_commission_2agent.toFixed(4)
      this.c2_commission_2yihe = c_commission_2yihe.toFixed(4)

      // 更新控件值
      if (isFlush) {
        this.new_policy_table.commission = c_commission
        this.new_policy_table.vat = c_vat
        this.new_policy_table.commission_2agent = c_commission_2agent
        this.new_policy_table.commission_2yihe = c_commission_2yihe
      }

      // 计算开票部分
      // this.calcInvoice('un_invoice_rate', isFlush)
      this.calcInvoice('general', isFlush)
    },
    // 计算开票信息
    calcInvoice(field, isFlush = true) {
      let c_premium = parseFloat(this.new_policy_table.premium)
      let c_commission = parseFloat(this.new_policy_table.commission)
      let c_invoice = parseFloat(this.new_policy_table.invoice)
      let c_un_invoice = parseFloat(this.new_policy_table.un_invoice)

      let c_commission_rate = parseFloat(this.new_policy_table.commission_rate)
      let c_invoice_rate = parseFloat(this.new_policy_table.invoice_rate)
      let c_un_invoice_rate = parseFloat(this.new_policy_table.un_invoice_rate)

      if (field === 'invoice_rate') {
        if (c_invoice_rate < 0) {
          c_invoice_rate = 0
          if (isFlush) {
            this.new_policy_table.invoice_rate = 0
          }
        }
        if (c_invoice_rate > c_commission_rate) {
          c_invoice_rate = c_commission_rate
          if (isFlush) {
            this.new_policy_table.invoice_rate = c_commission_rate
          }
        }
        c_un_invoice_rate = c_commission_rate - c_invoice_rate
        c_invoice = (c_premium * c_invoice_rate) / this.new_policy_table.vat_rate
        c_un_invoice = (c_premium * c_un_invoice_rate) / this.new_policy_table.vat_rate

      } else if (field === 'un_invoice_rate') {
        if (c_un_invoice_rate < 0) {
          c_un_invoice_rate = 0
          if (isFlush) {
            this.new_policy_table.un_invoice_rate = 0
          }
        }
        if (c_un_invoice_rate > c_commission_rate) {
          c_un_invoice_rate = c_commission_rate
          if (isFlush) {
            this.new_policy_table.un_invoice_rate = c_commission_rate
          }
        }
        c_invoice_rate = c_commission_rate - c_un_invoice_rate
        c_invoice = (c_premium * c_invoice_rate) / this.new_policy_table.vat_rate
        c_un_invoice = (c_premium * c_un_invoice_rate) / this.new_policy_table.vat_rate

      } else if (field === 'invoice') {
        if (c_invoice < 0) {
          c_invoice = 0
          if (isFlush) {
            this.new_policy_table.invoice = 0
          }
        }
        if (c_invoice > c_commission) {
          c_invoice = c_commission
          if (isFlush) {
            this.new_policy_table.invoice = c_commission
          }
        }
        c_un_invoice = c_commission - c_invoice
        c_invoice_rate = c_invoice / c_premium
        c_un_invoice_rate = c_un_invoice / c_premium

      } else if (field === 'un_invoice') {
        if (c_un_invoice < 0) {
          c_un_invoice = 0
          if (isFlush) {
            this.new_policy_table.un_invoice = 0
          }
        }
        if (c_un_invoice > c_commission) {
          c_un_invoice = c_commission
          if (isFlush) {
            this.new_policy_table.un_invoice = c_commission
          }
        }
        c_invoice = c_commission - c_un_invoice
        c_invoice_rate = c_invoice / c_premium
        c_un_invoice_rate = c_un_invoice / c_premium
      }

      // console.log('计算结束===================================')
      // console.log('c_invoice:' + c_invoice)
      // console.log('c_un_invoice:' + c_un_invoice)
      // console.log('c_commission:' + c_commission)
      // console.log('c_invoice_rate:' + c_invoice_rate)
      // console.log('c_un_invoice_rate:' + c_un_invoice_rate)
      // console.log('c_commission_rate:' + c_commission_rate)

      // 缓存计算结果
      this.c2_invoice = parseFloat(c_invoice).toFixed(4)
      this.c2_un_invoice = parseFloat(c_un_invoice).toFixed(4)
      this.c2_invoice_rate = c_invoice_rate
      this.c2_un_invoice_rate = c_un_invoice_rate

      // 更新控件值
      if (isFlush) {
        if (field !== 'invoice') {
          this.new_policy_table.invoice = parseFloat(c_invoice).toFixed(4)
        }
        if (field !== 'un_invoice') {
          this.new_policy_table.un_invoice = parseFloat(c_un_invoice).toFixed(4)
        }
        if (field !== 'invoice_rate') {
          this.new_policy_table.invoice_rate = c_invoice_rate
        }
        if (field !== 'un_invoice_rate') {
          this.new_policy_table.un_invoice_rate = c_un_invoice_rate
        }
      }
    },

    popupMessage(content, title, buttonText = '确定', messageType = 'info') {
      this.$alert(content, title, {
        confirmButtonText: buttonText,
        type: messageType,
        dangerouslyUseHTMLString: true
      });
    },

    getCheckMessage() {
      let c_premium = parseFloat(this.new_policy_table.premium)
      let c_commission_rate = parseFloat(this.new_policy_table.commission_rate)
      let c_commission = parseFloat(this.new_policy_table.commission)
      let c_invoice_rate = parseFloat(this.new_policy_table.invoice_rate)
      let c_invoice = parseFloat(this.new_policy_table.invoice)
      let c_un_invoice_rate = parseFloat(this.new_policy_table.un_invoice_rate)
      let c_un_invoice = parseFloat(this.new_policy_table.un_invoice)
      let c_commission_2agent_rate = parseFloat(this.new_policy_table.commission_2agent_rate)
      let c_commission_2agent = parseFloat(this.new_policy_table.commission_2agent)
      let c_vat = parseFloat(this.new_policy_table.vat)
      let c_commission_2yihe = parseFloat(this.new_policy_table.commission_2yihe)

      this.calcCommission(false)

      const hl_str = ' style="color:red;" '
      let hl_commission = ''
      let hl_commission_2agent = ''
      let hl_vat = ''
      let hl_commission_2yihe = ''
      let hl_invoice_rate = ''
      let hl_invoice = ''
      let hl_un_invoice_rate = ''
      let hl_un_invoice = ''
      if ((c_commission - this.c2_commission) !== 0) {
        hl_commission = hl_str
      }
      if ((c_commission_2agent - this.c2_commission_2agent) !== 0) {
        hl_commission_2agent = hl_str
      }
      if ((c_vat - this.c2_vat) !== 0) {
        hl_vat = hl_str
      }
      if ((c_commission_2yihe - this.c2_commission_2yihe) !== 0) {
        hl_commission_2yihe = hl_str
      }
      if ((c_invoice_rate - this.c2_invoice_rate) !== 0) {
        hl_invoice_rate = hl_str
      }
      if ((c_invoice - this.c2_invoice) !== 0) {
        hl_invoice = hl_str
      }
      if ((c_un_invoice_rate - this.c2_un_invoice_rate) !== 0) {
        hl_un_invoice_rate = hl_str
      }
      if ((c_un_invoice - this.c2_un_invoice) !== 0) {
        hl_un_invoice = hl_str
      }
      let message = `
        <table border="1" width="100%">
          <tr>
            <th>项目</th>
            <th>当前值</th>
            <th>计算值</th>
          </tr>
          <tr>
            <td>保费</td>
            <td>${c_premium}元</td>
            <td>${c_premium}元</td></tr>
          <tr>
            <td>手续费比例</td>
            <td>${c_commission_rate}</td>
            <td>${c_commission_rate}</td></tr>
          <tr>
            <td>手续费税率调整</td>
            <td>${this.new_policy_table.vat_rate}</td>
            <td>${this.new_policy_table.vat_rate}</td></tr>
          <tr>
            <td>手续费收入</td>
            <td><span ${hl_commission}>${c_commission}元</span></td>
            <td>${this.c2_commission}元</td></tr>
          <tr>
            <td>开票金额比例</td>
            <td><span ${hl_invoice_rate}>${c_invoice_rate}</span></td>
            <td>${this.c2_invoice_rate}</td></tr>
          <tr>
            <td>开票金额</td>
            <td><span ${hl_invoice}>${c_invoice}元</span></td>
            <td>${this.c2_invoice}元</td></tr>
          <tr>
            <td>不开票金额比例</td>
            <td><span ${hl_un_invoice_rate}>${c_un_invoice_rate}</span></td>
            <td>${this.c2_un_invoice_rate}</td></tr>
          <tr>
            <td>不开票金额</td>
            <td><span ${hl_un_invoice}>${c_un_invoice}元</span></td>
            <td>${this.c2_un_invoice}元</td></tr>
          <tr>
            <td>佣金支付比例</td>
            <td>${c_commission_2agent_rate}</td>
            <td>${c_commission_2agent_rate}</td></tr>
          <tr>
            <td>佣金支出</td>
            <td><span ${hl_commission_2agent}>${c_commission_2agent}元</td></span>
            <td>${this.c2_commission_2agent}元</td></tr>
          <tr>
            <td>税金扣减</td>
            <td><span ${hl_vat}>${c_vat}元</span></td>
            <td>${this.c2_vat}元</td></tr>
          <tr>
            <td>乙禾手续费</td>
            <td><span ${hl_commission_2yihe}>${c_commission_2yihe}元</span></td>
            <td>${this.c2_commission_2yihe}元</td></tr>
        </table>
        <br/>
        请确认当前所填金额是否正确，<span style="color:#ff0000">红色字提示部分，是与计算所得不同的当前值</span>，
        如确认则数据将直接进行保存，如不正确请取消后进行修改！
        `
      return message
    },
    /* 费用计算及检查结束 */


    /* 保单附件列表操作开始 */
    // 获取保单附件列表
    handleGetPolicyTableAttachmentList(policy_id) {
      fetchPolicyTableAttachmentList(policy_id)
        .then(resp => {
          this.attachment_list = resp
        }).catch(err => {
          this.$error_message(err)
        })
    },
    // 删除保单附件
    handleRemoveAttachmentFile(file, fileList) {
      deletePolicyTableAttachment(file.id)
        .then(resp => {
          this.$message.success('附件已被删除')
        }).catch(err => {
          this.$error_message(err)
        })
    },
    beforeRemoveAttachmentFile(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 预览保单附件
    handlePreviewAttachmentFile(file) {
      window.open(file.url, "_blank")
    },
    /* 保单附件列表操作结束 */


    /* 视图处理开始 */
    // 创建
    handleCreate() {
      this.pageStatus = 'action.add'
      this.loadData()
    },
    // 查看
    handleView(id) {
      console.log('Enter handleView()')
      this.pageStatus = 'action.view'
      this.loadData()
      let p = []
      p.push(fetchPolicyTable(id))
      p.push(fetchPolicyTableAttachmentList(id))
      p.push(fetchPolicyTableCorrectList(id))
      // this.handleGetPolicyTableAttachmentList(id)
      Promise.all(p)
        .then(res => {
          this.new_policy_table = Object.assign({}, res[0])
          this.attachment_list = res[1]
          this.correct_list = res[2]
          this.getIsGroupInsuranceValue()
          this.getIsBidValue()
          this.getIsCoInsuranceValue()
          this.initBusinessArea()
          // 处理扩展字段
          // if (JSON.stringify(this.new_policy_table.ext_info) !== "{}") {
          //   Object.keys(this.new_policy_table.ext_info).forEach(key => {
          //     this.$set(this.new_policy_table, key, this.new_policy_table.ext_info[key])
          //   })
          //   this.new_policy_table.ext_info = undefined
          // }
          // if(!this.new_policy_table.tag_list) {
          //   this.$set(this.new_policy_table, 'tag_list', [])
          // }

          // this.loadFileList("customer.customer", this.new_policy_table.id)

          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    // 编辑
    handleUpdate(id) {
      this.pageStatus = 'action.edit'
      this.loadData()
      // this.handleGetPolicyTableAttachmentList(id)
      let p = []
      p.push(fetchPolicyTable(id))
      p.push(fetchPolicyTableAttachmentList(id))
      p.push(fetchPolicyTableCorrectList(id))
      Promise.all(p)
        .then(res => {
          this.new_policy_table = Object.assign({}, res[0])
          this.attachment_list = res[1]
          this.correct_list = res[2]
          this.getIsGroupInsuranceValue()
          this.getIsBidValue()
          this.getIsCoInsuranceValue()
          this.initBusinessArea()
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    /* 视图处理结束 */



    /* 数据操作 */
    cancelData() {
      this.$refs.dataForm.resetFields()
      this.reset_options()
      this.reset_new_policy_table()
      this.$router.push({ name: 'policyTableList' })
    },
    saveData(save_type) {
      // 必填项检查
      let title = `《${this.new_policy_table.ship_name}》金额内容确认`
      // let r_biz = this.$refs.biz_info_input.validate()
      // let r_biz_rel = this.$refs.biz_relation_info_input.validate()
      // let r_fin = this.$refs.fin_info_input.validate()
      // let r = r_biz.concat(r_biz_rel).concat(r_fin)
      // let r = r_biz.concat(r_biz_rel)
      // if (r.length > 0){
      //   let message = '选项 ' + r.join(',') + ' 为必填项！'
      //   this.$message.error(message)
      //   return
      // }
      let r_biz = this.$refs.biz_info_input.validate()
      if (r_biz.length > 0){
        let message = '选项 ' + r_biz.join(',') + ' 为必填项！'
        this.$message.error(message)
        return
      }

      this.$confirm(this.getCheckMessage(), title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        if (this.new_policy_table.is_reconciled === 1) {
          this.$confirm('保单已对账，只允许修改附件文件, 是否继续?', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.doSaveData(save_type)
          }
          ).catch((e) => {
            console.log(e)
            this.$message.info("操作取消")
          });
        } else {
          this.doSaveData(save_type)
        }
      }).catch(() => {
        this.loading = false
      });
    },
    // 检查表单有效性，分别处理有新增附件和没有新增附件的情况
    doSaveData(save_type) {
      this.save_type = save_type
      this.submitForm = new FormData()
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          if (this.hasNewAttachmentFile()) {
            // 带附件的提交
            this.$refs.upload.submit()
            this.handleSubmit()
          } else {
            // 不带附件的提交
            this.handleSubmit()
          }
        }
      })
    },
    hasNewAttachmentFile() {
      // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
      let hasNew = false
      if (this.$refs.upload.uploadFiles.length > 0) {
        for (let f of this.$refs.upload.uploadFiles) {
          if ('raw' in f) {
            hasNew = true
            break
          }
        }
        return hasNew
      }
    },
    addAttachment(file) {
      this.submitForm.append('file', file.file)
    },
    // 带附件提交修改
    handleSubmit() {
      this.loading = true
      this.loadingText = '正在保存保单数据，请稍等...'

      // let fd = new FormData()
      // 填充表单数据，只对未进行对账的保单进行数据变更
      if (this.new_policy_table.is_reconciled !== 1) {
        this.submitForm.set('id', this.new_policy_table.id)
        this.submitForm.set('no', this.new_policy_table.no)

        // 业务信息
        this.submitForm.set('policy_number', this.new_policy_table.policy_number)
        this.submitForm.set('ship_name', this.new_policy_table.ship_name)
        this.submitForm.set('insured', this.new_policy_table.insured)
        this.submitForm.set('applicant', this.new_policy_table.applicant)
        this.submitForm.set('insurance_company', this.new_policy_table.insurance_company)
        this.submitForm.set('insurance_company_branch_office', this.new_policy_table.insurance_company_branch_office)
        this.submitForm.set('business_type', this.new_policy_table.business_type)

        this.submitForm.set('effective_date', this.getDateTime(this.new_policy_table.effective_date))
        this.submitForm.set('expiration_date', this.getDateTime(this.new_policy_table.expiration_date))
        this.submitForm.set('issue_month', this.getDateTime(this.new_policy_table.issue_month))
        this.submitForm.set('insurance_type', this.new_policy_table.insurance_type)
        this.submitForm.set('insurance_type_code', this.new_policy_table.insurance_type_code)
        this.submitForm.set('has_receipt', this.new_policy_table.has_receipt)

        // 业务关系
        this.submitForm.set('referrer', this.new_policy_table.referrer)
        this.submitForm.set('business_area', this.new_policy_table.business_area)
        this.submitForm.set('business_source', this.new_policy_table.business_source)
        this.submitForm.set('escrow_agent', this.new_policy_table.escrow_agent)
        this.submitForm.set('is_group_insurance', this.new_policy_table.is_group_insurance)
        this.submitForm.set('is_bid', this.new_policy_table.is_bid)
        this.submitForm.set('is_coinsurance', this.new_policy_table.is_coinsurance)

        // 财务信息
        this.submitForm.set('vat_rate', this.new_policy_table.vat_rate)
        this.submitForm.set('commission_rate', this.new_policy_table.commission_rate)
        this.submitForm.set('invoice_rate', this.new_policy_table.invoice_rate)
        this.submitForm.set('un_invoice_rate', this.new_policy_table.un_invoice_rate)
        this.submitForm.set('commission_2agent_rate', this.new_policy_table.commission_2agent_rate)

        this.submitForm.set('premium', this.new_policy_table.premium)
        this.submitForm.set('commission', this.new_policy_table.commission)
        this.submitForm.set('invoice', this.new_policy_table.invoice)
        this.submitForm.set('un_invoice', this.new_policy_table.un_invoice)
        this.submitForm.set('commission_2agent', this.new_policy_table.commission_2agent)
        this.submitForm.set('vat', this.new_policy_table.vat)
        this.submitForm.set('commission_2yihe', this.new_policy_table.commission_2yihe)

        // this.submitForm.set('commission_collection_date', this.getDateTime(this.new_policy_table.commission_collection_date))
        // this.submitForm.set('commission_2agent_paid_date', this.getDateTime(this.new_policy_table.commission_2agent_paid_date))

        // 船舶信息
        this.submitForm.set('ship_age', this.new_policy_table.ship_age)
        this.submitForm.set('port_of_registry', this.new_policy_table.port_of_registry)
        this.submitForm.set('ship_type', this.new_policy_table.ship_type)
        this.submitForm.set('total_tons', this.new_policy_table.total_tons)
        this.submitForm.set('dwt', this.new_policy_table.dwt)
        this.submitForm.set('sailing_area', this.new_policy_table.sailing_area)

        this.submitForm.set('group_ids', this.new_policy_table.group_ids)
        this.submitForm.set('group_names', this.new_policy_table.group_names)

        this.submitForm.set('remark', this.new_policy_table.remark)
        this.submitForm.set('clause', this.new_policy_table.clause)

        if (this.new_policy_table.services === undefined) {
          if (Array.isArray(this.new_policy_table.service_contents)) {
            this.new_policy_table.service_contents.forEach((item, i) => {
              if (item.policy_number === "" || item.policy_number === undefined) {
                item.policy_number = this.new_policy_table.policy_number
              }
            })
          }
          else {this.new_policy_table.service_contents = []}
          console.log(this.new_policy_table.service_contents)
          this.submitForm.set('services', JSON.stringify(this.new_policy_table.service_contents))
        } else {
          if (Array.isArray(this.new_policy_table.services)) {
            this.new_policy_table.services.forEach((item, i) => {
              if (item.policy_number === "" || item.policy_number === undefined) {
                item.policy_number = this.new_policy_table.policy_number
              }
            })
          }
          this.submitForm.set('services', JSON.stringify(this.new_policy_table.services))
        }

        if (this.new_policy_table.insureds === undefined) {
          this.submitForm.set('insureds', JSON.stringify([]))
        } else {
          this.submitForm.set('insureds', JSON.stringify(this.new_policy_table.insureds))
        }
      }

      var del_keys = []
      this.submitForm.forEach((v, k) => {
        if (v === 'undefined' || typeof v === 'undefined') {
          del_keys.push(k)
        }
      })

      del_keys.forEach(k => {
        this.submitForm.delete(k)
      })

      if (this.save_type === 1 || this.save_type === 2) {
        this.createData()
      } else {
        this.updateData()
      }
    },
    createData() {
      this.loading = true
      createPolicyTable(this.submitForm)
        .then(res => {
          this.policyTableId = res.id
          this.loadingText = "保存保单信息成功"
        })
        .then(() => {
          this.loading = false
          this.$message.success('保存保单信息成功')
          this.$nextTick(() => {
            this.$refs.dataForm.clearValidate()
            this.$refs.dataForm.resetFields()
            this.reset_options()
            this.reset_new_policy_table()
            if (this.save_type === 1) {
              setTimeout(() => {
                this.$router.push({ name: 'policyTableList' })
              }, 1000)
            }
          })
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
    },
    updateData() {
      this.loading = true
      updatePolicyTable(this.new_policy_table.id, this.submitForm)
        .then(() => {
          this.loading = false
          this.$message.success('保存保单信息成功')
          this.$nextTick(() => {
            this.$refs.dataForm.clearValidate()
            this.$refs.dataForm.resetFields()
            this.reset_options()
            this.reset_new_policy_table()
            setTimeout(() => {
              this.$router.push({ name: 'policyTableList' })
            }, 1000)
          })
        })
        .catch(error => {
          this.loading = false
          this.$message.error(error)
        })
    },
    handleBizInfoChange(val) {
      this.new_policy_table.policy_number = val.policy_number
      this.new_policy_table.ship_name = val.ship_name
      this.new_policy_table.insured = val.insured
      this.new_policy_table.applicant = val.applicant
      this.new_policy_table.effective_date = val.effective_date
      this.new_policy_table.expiration_date = val.expiration_date
      this.new_policy_table.issue_month = val.issue_month
      this.new_policy_table.business_type = val.business_type
      this.new_policy_table.premium = val.premium
    },
    handleBizRelationInfoChange(val) {
      this.new_policy_table.business_area = val.business_area
      this.new_policy_table.business_source = val.business_source
      this.new_policy_table.referrer = val.referrer
      this.new_policy_table.escrow_agent = val.escrow_agent
      this.new_policy_table.group_ids = val.group_ids
      this.new_policy_table.group_names = val.group_names
      this.new_policy_table.business_area = val.group_names.join(',')
    },
    handleFinInfoChange(val) {
      this.new_policy_table.insurance_company = val.insurance_company
      this.new_policy_table.insurance_company_branch_office = val.insurance_company_branch_office
      this.new_policy_table.insurance_type = val.insurance_type
      this.new_policy_table.commission_rate = val.commission_rate
      this.new_policy_table.commission_2agent_rate = val.commission_2agent_rate
      this.new_policy_table.vat_rate = val.vat_rate
      this.new_policy_table.premium = val.premium
      this.new_policy_table.commission = val.commission
      this.new_policy_table.commission_2agent = val.commission_2agent
      this.new_policy_table.vat = val.vat
      this.new_policy_table.commission_2yihe = val.commission_2yihe
      this.new_policy_table.invoice_rate = val.invoice_rate
      this.new_policy_table.un_invoice_rate = val.un_invoice_rate
      this.new_policy_table.invoice = val.invoice
      this.new_policy_table.un_invoice = val.un_invoice
      // this.new_policy_table.is_group_insurance = val.is_group_insurance
      // this.isGroupInsurance = val.is_group_insurance
      this.new_policy_table.services = val.services
    },
    handleSimpleFinInfoChange(val) {
      this.new_policy_table.insurance_company = val.insurance_company
      this.new_policy_table.insurance_company_branch_office = val.insurance_company_branch_office
      this.new_policy_table.insurance_type = val.insurance_type
      this.new_policy_table.commission_2agent_rate = val.commission_2agent_rate
      this.new_policy_table.premium = val.premium
      this.new_policy_table.commission_2agent = val.commission_2agent
      this.new_policy_table.services = val.services
    },
    handleShipInfoChange(val) {
      this.new_policy_table.ship_age = val.ship_age
      this.new_policy_table.port_of_registry = val.port_of_registry
      this.new_policy_table.ship_type = val.ship_type
      this.new_policy_table.sailing_area = val.sailing_area
      this.new_policy_table.total_tons = val.total_tons
      this.new_policy_table.dwt = val.dwt
    },
    handleInsuredInfoChange(val) {
      this.new_policy_table.insureds = val
    },
    test() {
      this.new_policy_table.premium = 10000
      this.new_policy_table.ship_name = '船名'
      this.new_policy_table.insured = '被保险人'
      this.new_policy_table.effective_date = '2021-8-1'
      this.new_policy_table.expiration_date = '2022-8-2'
      this.new_policy_table.issue_month = '2021-8-1'
      this.new_policy_table.business_type = '新增'
      this.new_policy_table.business_area = '承保部'
    },
    toView(id) {
      let route = this.$router.resolve({ name: 'viewPolicyTable', query: { id: id } })
      open(route.href, "_blank")
    },
    toEdit(id) {
      let route = this.$router.resolve({ name: 'updatePolicyTable', query: { id: id } })
      open(route.href, "_blank")
    },
    handleClause() {
      var msg = '确定已经补充条款？'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$set(this.new_policy_table, 'clause', '')
      })
    }
  },
  /* 页面视图初始化 */
  beforeRouteLeave (to, from, next) {
        if (to.name != 'policyTableList') {
          window.localStorage.removeItem('query')
        }
        next()
        },
  created() {
    // this.test()
    if (this.$perm(['super.change_super_permission'])) {
      this.showFinanceInfo = true
      this.showFinanceInfoSimple = true
    }

    // 根据路由名称，判断是创建新的总保单还是更新总保单,如果更新路由中不带id参数则认为是错误请求
    // 保创建单视图
    if (this.$route.name === 'createPolicyTable') {
      if (!this.$perm(["policy.create_policy_table"])) {
        this.$router.push('/401')
      }
      if (this.$perm(["policy.export_policy_table"])) {
        this.showFinanceInfo = true
      }
      else {
        this.showFinanceInfoSimple = true
      }
      this.showAdd = true
      this.notRestricted = true
      this.handleCreate()
      return
    }

    // 保单查看视图
    this.id = this.$route.query.id
    if (this.id === undefined || this.id === null || this.id === '') {
      this.$router.push('/404')
    }

    if (this.$route.name === 'viewPolicyTable') {
      if (!(this.$perm(["policy.view_policy_table",
        "policy.restricted_view_policy_table",
        "policy.very_restricted_view_policy_table"]))) {
        this.$router.push('/401')
      }

      if (this.$perm(["policy.view_policy_table"])) {
        this.notRestricted = true
        this.handleView(this.id)
        return
      }

      if (this.$perm(["policy.restricted_view_policy_table", "policy.very_restricted_view_policy_table"])) {
        this.handleView(this.id)
        return
      }
    }

    // 保单更新视图
    if (!this.$perm(["policy.update_policy_table"])) {
      this.$router.push('/401')
    } else {
      this.policyTableId = this.id
      this.showEdit = true
      this.notRestricted = true
      this.handleUpdate(this.policyTableId)
    }

    if (this.$perm(["policy.export_policy_table"])) {
      this.showFinanceInfo = true
    }
    else {
      this.showFinanceInfoSimple = true
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}

.formula_form {
  line-height: 18px;
  font-weight: bold;
}

.formula_form_head {
  color: red;
  font-weight: bold;
  line-height: 18px;
}
</style>
